module.exports = __webpack_public_path__ + "img/housing-alerts-affiliate.31784f8f.svg";